import {WorldService} from '../../libs/ui/src';

import {client} from '../apiService';
const _WorldService = new WorldService({client});
export {_WorldService as WorldService};
